import { render, staticRenderFns } from "./AccessPageNext.vue?vue&type=template&id=6c44f1e5&scoped=true"
import script from "./AccessPageNext.vue?vue&type=script&lang=js"
export * from "./AccessPageNext.vue?vue&type=script&lang=js"
import style0 from "./AccessPageNext.vue?vue&type=style&index=0&id=6c44f1e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44f1e5",
  null
  
)

export default component.exports